import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import {
  MemphisOperatorListFilters,
  MemphisOperatorRepository,
} from '@app/domain/ports/tpv/memphis-operator.repository';
import { TpvMemphisOperator } from '@app/domain/models/tpv/memphis-operator.model';
import { TpvPage } from '@app/domain/models/tpv/tpv-page.model';
import { TpvReportFile, TpvReportFormat } from '@app/domain/models/tpv/tpv-report.model';

/** Mock de operadores Memphis para pruebas sin backend (tpvUseMocks). */
@Injectable()
export class MemphisOperatorMockDataSource extends MemphisOperatorRepository {
  private readonly operators: TpvMemphisOperator[] = [
    { idOperador: 'OP-001', name: 'Juan', lastNamePaternal: 'Pérez', lastNameMaternal: 'García', fullName: 'Juan Pérez García', email: 'juan.perez@demo.io', active: true, createdAt: '2026-01-10', updatedAt: '2026-06-01', idUserMemphis: 101 },
    { idOperador: 'OP-002', name: 'María', lastNamePaternal: 'López', lastNameMaternal: 'Ruiz', fullName: 'María López Ruiz', email: 'maria.lopez@demo.io', active: true, createdAt: '2026-02-15', updatedAt: '2026-05-20', idUserMemphis: 102 },
    { idOperador: 'OP-003', name: 'Carlos', lastNamePaternal: 'Sánchez', lastNameMaternal: 'Mora', fullName: 'Carlos Sánchez Mora', email: 'carlos.sanchez@demo.io', active: false, createdAt: '2026-03-05', updatedAt: '2026-04-30', idUserMemphis: 103 },
  ];

  override listOperators(
    filters: MemphisOperatorListFilters = {},
  ): Observable<TpvPage<TpvMemphisOperator>> {
    return of({
      data: this.operators,
      total: this.operators.length,
      page: filters.page ?? 1,
      limit: filters.limit ?? 10,
    }).pipe(delay(300));
  }

  override getOperatorsReport(
    _format: TpvReportFormat,
    _filters: Omit<MemphisOperatorListFilters, 'page' | 'limit'>,
  ): Observable<TpvReportFile> {
    return of<TpvReportFile>({
      fileName: 'mock_operadores.xlsx',
      fileBase64: 'bW9jayByZXBvcnQ=',
      fileSize: 11,
    }).pipe(delay(300));
  }
}
